import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint, width } from '@twistopayments/design-system/styles';

export const wrapper = css`
  display: block;
  position: relative;
  transform-origin: center;
  transform-style: preserve-3d;
  background: none;

  /* vertically center modal */
  margin: 0 auto;
`;

export const disabledScroll = css`
  max-height: 100%;
  overflow-y: hidden;
`;

export const verticalAlign = {
  center: () => css`
    align-self: center;
  `,
  top: (theme: Theme) => css`
    align-self: start;
    margin: ${theme.spacing[48]} auto;

    ${breakpoint.up('sm')} {
      margin: ${theme.spacing[96]} auto;
    }
  `,
};

export const variants = {
  default: () => css`
    width: 100%;
    max-width: 580px;
  `,
  centered: () => css`
    width: 100%;
    max-width: 580px;
    text-align: center;
  `,
  /* Only the mobile overrides live in a media query, so the desktop layout keeps
  the shared `wrapper` centering and stays overridable by `modalWrapperStyles`. */
  fullScreenMobile: () => css`
    width: 100%;
    max-width: 580px;

    ${breakpoint.down('xs')} {
      height: 100%;
      max-width: none;
    }
  `,
  wide: (theme: Theme) => css`
    width: 100%;
    height: 100%;
    margin: ${theme.spacing[0]} auto;
    position: fixed;
    overflow-y: hidden;
    top: 0;
    left: 0;

    ${breakpoint.up('sm')} {
      position: relative;
      width: 87.7%;
      max-height: 1080px;
      max-width: ${width.modal.maxWidth};
    }
  `,
};

export const autoWidth = css`
  width: auto;
  max-width: 100%;
`;

export const content = (theme: Theme) => css`
  position: relative;
  white-space: normal;
  min-height: 100px;
  width: 100%;
  overflow: hidden;
  padding: ${theme.spacing[24]} ${theme.spacing[16]};
  border-radius: ${theme.presentation.surface.modalCorners};

  background: ${theme.palette.background.main};

  ${breakpoint.up('sm')} {
    padding: ${theme.spacing[32]} ${theme.spacing[24]};
    margin: 0;
  }

  ${breakpoint.up('md')} {
    padding: ${theme.presentation.surface.modalDesktopPadding};
    ${theme.presentation.surface.modalDesktopCorners && css`
      border-radius: ${theme.presentation.surface.modalDesktopCorners};
    `}
    margin: 0;
  }

`;

export const wideContent = css`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const fullScreenMobileContent = () => css`
  ${breakpoint.down('xs')} {
    height: 100%;
    border-radius: 0;
    overflow-y: auto;
  }
`;

export const fullScreenMobileOverlay = () => css`
  ${breakpoint.down('xs')} {
    padding: 0;
  }
`;

export const noPadding = css`
  padding: 0;

  ${breakpoint.up('sm')} {
    padding: 0;
  }
`;
